import { FilterActions as Container } from "./styles";

export function FilterActions({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>;
}
